// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3C4JB","resendInfoText":"OnGoingPaymentBox_resendInfoText__2STYL"};